import { gql } from "apollo-boost"

export const getTechnicalMonitoring = gql`
  query TechnicalMonitoring($id: ID!,  $skip: Float, $first: Float) {
    Submission:TechnicalMonitoring(id: $id, first: $first, skip: $skip) {
      id
      endDate
      startDate
      specificObjectives {
        id
        orderIndex
        description
        indicators {
          id
          isBlocking
          goal
          type
          title
          endDate
          startDate
          orderIndex
          description
          meansOfVerification
        }
        activities {
          id
          isBlocking
          goal
          title
          orderIndex
          description
          responsible
          meansOfVerification
          schedules {
            id
            place
            scheduledAt
            completedAt
            startTime
            endTime
            createdAt
          }
        }
      }
      developmentObjectiveIndicators {
        id
        goal
        type
        title
        endDate
        startDate
        methodology
        description
        meansOfVerification
      }
      generalObjectiveIndicators {
        id
        type
        goal
        title
        endDate
        startDate
        description
        meansOfVerification
        measurementPeriodicity
      }
      state
      status
      technicalMonitoringReports{
        id
        key
        goal
        appliedAt
        completed
        compliance
        reviewedAt
        verificationDocuments{
          id
          name
          url
        }
        participants{
          id
          age
          type
          amount
          gender
          preventionLevel
        }
      }
      technicalUpdates{
        id
        createdAt
        obstacles
        challenges
        correctiveActions
      }
      createdAt
      projectBeneficiaries{
        id
        name
        curp
        phone
        folio
        state
        gender
        colony
        lastName
        birthdate
        maidenName
        municipality
        projectAssistantId
      }
    }
  }
`

export const getScheduling = gql`
  query scheduling($id: ID!,  $skip: Float, $first: Float, $date: String, $month: String) {
    Submission:Scheduling(id: $id, first: $first, skip: $skip, date: $date, month:$month) {
      id
      startDate
      endDate
      specificObjectives {
        orderIndex
        activities {
          id
          orderIndex
          title
          place
        }
      }
    }
  }
`


export const getSchedulingList = gql`
  query schedulingList($schedulingListId: ID!, $skip: Float, $first: Float,  $date: String, $month: String) {
  SchedulingList(id: $schedulingListId,  date: $date,  skip: $skip, first: $first,  month:$month) {
    id
    place
    scheduledAt
    completedAt
    startTime
    endTime
    createdAt
  }
  SchedulingListTotal(id: $schedulingListId,  date: $date,  month:$month)
}
`

export const getProjectDate = gql`
  query Query($getProjectDateId: ID!) {
  GetProjectDate(id: $getProjectDateId) {
    statusChangedAt
  }
}
`